<template>
  <div class="w-96" v-if="user">
    <h1 class="mb-2 font-medium">Information</h1>
    <div class="flex flex-col space-y-4">
      <div class="relative border rounded-xl">
        <input
          type="text"
          id="name"
          class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-500 focus:outline-none focus:ring-0 focus:border-primary peer"
          placeholder=""
          v-model="user.name"
        />
        <label
          for="name"
          class="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-secondary peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
          >Name</label
        >
      </div>
      <div class="relative bg-gray-100 border rounded-xl">
        <input
          type="email"
          id="email"
          class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-500 focus:outline-none focus:ring-0 focus:border-primary peer"
          v-model="user.email"
          disabled
        />
        <label
          for="email"
          class="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-secondary peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
          >Email</label
        >
      </div>
      <button
        class="w-full p-3 mt-5 text-sm font-semibold text-white rounded-lg hover:bg-primary bg-secondary"
        @click="updateUser"
      >
        Update
      </button>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import useAuth from "@/composables/useAuth";

export default {
  setup() {
    const store = useStore();
    const { state } = useAuth(store);
    const isAuthenticated = ref(state.isAuthenticated);

    watch(
      () => state.isAuthenticated,
      (newVal) => {
        isAuthenticated.value = newVal;
      }
    );

    const user = computed(() => state.user);

    const updateUser = () => {
      store.dispatch("updateUser", {
        name: user.value.name,
        email: user.value.email,
      });
    };

    return {
      user,
      isAuthenticated,
      updateUser,
    };
  },
};
</script>

<style scoped>
/* CSS */
.nav-link {
  transition: font-weight 0.2s ease;
  color: #4f4f4f;
  font-size: 14.5px;
  font-weight: 400;
}
.active-link {
  font-weight: bolder !important;
  color: #ef5d4e !important;
}
</style>
